// extracted by mini-css-extract-plugin
module.exports = {"hideForHamburger":"style_hideForHamburger__3CpzF"};